var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBackLogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01836 7.3897C4.72547 7.6826 4.2506 7.6826 3.95771 7.3897L1.18677 4.61877C0.893877 4.32587 0.893877 3.851 1.18677 3.55811L3.95771 0.78717C4.2506 0.494277 4.72547 0.494276 5.01837 0.78717C5.31126 1.08006 5.31126 1.55494 5.01837 1.84783L3.52776 3.33844L10.375 3.33844C10.7892 3.33844 11.125 3.67422 11.125 4.08844C11.125 4.50265 10.7892 4.83844 10.375 4.83844L3.52776 4.83844L5.01837 6.32904C5.31126 6.62194 5.31126 7.09681 5.01836 7.3897Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackLogIcon);
export default __webpack_public_path__ + "static/media/go-back-log-icon.68be7d303bb4612256dc7711e640394a.svg";
export { ForwardRef as ReactComponent };